import type { MetricOption } from '../../types/geoAnalytics'

const TRAILING_YEAR = /^(.*)\.((?:19|20)\d{2})$/

export function extractFamilyYear(key: string): { family: string; year: number | null } {
  const m = TRAILING_YEAR.exec(key)
  return m ? { family: m[1], year: Number(m[2]) } : { family: key, year: null }
}

/** family → sorted years present (families with no year-scoped keys map to []). */
export function familyYears(keys: string[]): Record<string, number[]> {
  const out: Record<string, number[]> = {}
  for (const key of keys) {
    const { family, year } = extractFamilyYear(key)
    out[family] ??= []
    if (year != null) out[family].push(year)
  }
  for (const family of Object.keys(out)) out[family].sort((a, b) => a - b)
  return out
}

/** Years with a per-cycle lean metric — drives swing-arrow availability. */
export function leanYears(keys: string[]): number[] {
  return familyYears(keys)['lean'] ?? []
}

/** Options whose data actually exists for the current (state, unitType) scope. */
export function visibleMetricOptions(options: MetricOption[], availableKeys: string[]): MetricOption[] {
  const families = familyYears(availableKeys)
  return options.filter(o =>
    o.requiresYear ? (families[o.key]?.length ?? 0) > 0 : o.key in families,
  )
}
